import React from 'react';

function NotFound() {
  return (
    <h1>página não encontrada</h1>
  )
}

export default NotFound;
